export default __webpack_public_path__ + "static/media/headerBackground.5bf7a2f0.jpg";